import { MealsScreen } from '~/meal/components/meals-screen/MealsScreen';

export default MealsScreen;
